import React, { createContext, useState } from 'react';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const SelectionsUnavailableReasonsStateContext = createContext();

export const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  items: [],
  areItemsLoaded: false
};

const SelectionsUnavailableReasonsContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <SelectionsUnavailableReasonsStateContext.Provider value={stateHook}>
      {children}
    </SelectionsUnavailableReasonsStateContext.Provider>
  );
};

export default SelectionsUnavailableReasonsContextProvider;